import { SalesChannelValues } from "@redotech/redo-analytics-common/returns-claims/filters/sales-channel-values";
import { ViewByEnum } from "@redotech/redo-analytics-common/returns-claims/filters/view-by-toggle";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum ClaimsTabDateType {
  CLAIM_SUBMITTED_DATE = "claim_submitted_date",
  ORDER_DATE = "order_date",
  CLAIM_COMPLETED_DATE = "claim_completed_date",
}

const orderSummarySchema = z.object({
  TOTAL_CLAIMS: z.number(),
  PROTECTED_ORDERS: z.number(),
  TOTAL_ORDERS: z.number(),
  PROTECTION_ELIGIBLE_ORDERS: z.number().optional(),
  ADOPTION_RATE: z.number(),
  TOTAL_PP_REVENUE: z.number(),
  PROTECTED_CLAIM_REVENUE: z.number(),
  UNPROTECTED_CLAIM_REVENUE: z.number(),
  REFUNDS: z.number(),
  RETAINED: z.number(),
});

const claimByCarrierSchema = z.object({
  CARRIER: z.string().nullable(),
  TOTAL_CLAIMS: z.number(),
  PROTECTED_CLAIM_REVENUE: z.number(),
  UNPROTECTED_CLAIM_REVENUE: z.number(),
});

export const getClaimsAnalyticsStatistics = {
  name: "getClaimsAnalyticsStatistics" as const,
  input: z.object({
    startDate: zExt.plainDate(),
    endDate: zExt.plainDate(),
    viewBy: z
      .enum([
        ViewByEnum.ORDER_DATE,
        ViewByEnum.PROCESSED_DATE,
        ViewByEnum.SUBMITTED_DATE,
      ])
      .default(ViewByEnum.ORDER_DATE)
      .describe(
        "Whether to view analytics by order date, processed date, or submitted date",
      ),
    salesChannels: z.array(z.enum(SalesChannelValues)).optional(),
  }),
  output: z.object({
    orderSummary: orderSummarySchema,
    claimsByCarrier: z.array(claimByCarrierSchema),
  }),
};

export type ClaimAnalyticsStatistics = z.infer<
  typeof getClaimsAnalyticsStatistics.output
>;

export type OrderSummary = z.infer<typeof orderSummarySchema>;

export type ClaimByCarrier = z.infer<typeof claimByCarrierSchema>;
